import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {ResidentForSelect} from '../../../types/models';
import {DirectoryService} from '../../../services/directory.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {DatePipe} from '@angular/common';
import {ParkingPassService} from '../../../services/parking-pass.service';
import {ConstantsService} from '../../../services/constants.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'parking-pass-detailed-view',
    templateUrl: './parking-pass-detailed-view.component.html',
    styleUrls: ['./parking-pass-detailed-view.component.scss']
})

export class ParkingPassDetailedViewComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;
    navPosition = 'info';
    comment = '';
    suites = [];
    residents = [];
    buildingSelectIsDisabled = false;
    maxDate = new Date();
    usedPasses: Array<any> = [];
    currentDate = '';
    gotUsedPasses = false;
    recentVisitorsList = [];
    gotRecentVisitors = false;

    constructor(public api: ApiClientService,
                public parkingPassService: ParkingPassService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService
    ) {
    }

    ngOnInit() {
        this.parkingPassService.onDetailedViewToggle.subscribe(() => {
            if (!this.authenticationService.userIsResident) {
                this.getNumberOfUsedPasses();
                this.getRecentVisitors();
            }
        });
        console.log(this.parkingPassService.selectedItemData);
    }

    onSubmit(data: any): void {
        const url = `/v1/incident_report/${this.parkingPassService.selectedItemData.id}.json`;
        this.parkingPassService.api.patch('domainIncidentReports', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.parkingPassService.toggleDetailedView(this.parkingPassService.selectedItemData, true);
        this.parkingPassService.getData();
        if (close) this.parkingPassService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        this.setEditModeForAll(false);
        if (fieldName != 'building' && fieldName != 'unit' && fieldName != 'resident') {
            item.formFields[fieldName].editMode = state;
            if (fieldName == 'incidentAt')
                setTimeout(() => this.initTimepicker(), 300);
        } else {
            if (state) {
                this.getSuites(this.parkingPassService.selectedItemData.buildingId, this.parkingPassService.selectedItemData.suiteId, form);
                if (this.parkingPassService.selectedItemData.suiteId === 0)
                    this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            item.formFields['building'].editMode = state;
            item.formFields['unit'].editMode = state;
            item.formFields['resident'].editMode = state;
        }
    }

    setEditModeForAll(state: boolean) {
        for (const field in this.parkingPassService.selectedItemData.formFields)
            this.parkingPassService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        if (form.dirty) {
            if (formField != 'incidentAt')
                item[formField] = form.value[formField];
            if (formField == 'building' || formField == 'unit' || formField == 'resident') {
                if (!form.value.building ||
                    !(form.value.unit || (form.value.unit === 0 && form.value.otherSuite)) ||
                    !(form.value.resident || (form.value.resident === 0 && form.value.otherResident))) {
                    toastr.warning('All details about building, unit and resident must be filled to proceed.');
                    return;
                }
                const building = this.parkingPassService.buildings.find((item) => +item.id === +form.value.building);
                const suite = this.suites.find((item) => +item.id === +form.value.unit);
                const resident = this.residents.find((item) => +item.id === +form.value.resident);
                changedValue = {
                    building: {
                        bdId: form.value.building,
                        name: building ? building.name : null,
                        address: building ? building.address : null,
                        corporationNumberBd: building ? building.corporationNumber : null,
                        timezone: building ? (building.timeZone ? building.timeZone.value : null) : null
                    },
                    suite: {
                        bdId: suite.id ? form.value.unit : 0,
                        suiteNumber: suite.id ? suite.name : form.value.otherSuite,
                    },
                    resident: {
                        bdId: resident.id ? resident.id : 0,
                        fullName: resident.id ? resident.fullName : form.value.otherResident,
                        //Fixme: add resident email
                    },
                };
            } else if (formField == 'incidentAt') {
                if (!form.value.incidentAt || !form.value.startTime) {
                    toastr.warning('All Start Date details must be filled to proceed.');
                    return;
                }
                changedValue = {incidentAt: this.getDateTimeFromForm('incidentAt', 'startTime')};
            }
            this.onSubmit(changedValue);
            if (form.valid) this.setEditModeForAll(false);
        } else {
            this.setEditModeForAll(false);
        }
    }

    changeBuilding(buildingId: string, form) {
        form.controls['unit'].reset();
        form.controls['resident'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(suite => this.suites.push({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        if (form.controls['resident'].value !== 0)
            form.controls['resident'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['resident'].setValue(0);
            setTimeout(() => {
                form.controls['otherSuite'].reset();
                form.controls['otherResident'].reset();
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if (form.value.unit !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    residents.forEach(item => {
                        this.residents.push(
                            new ResidentForSelect(item.id, item.fullName, [], item.email)
                        );
                    });
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }


    openTimepicker(): void {
        $('#timepicker').timepicker('showWidget');
    }

    getTime(dateString) {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    getDateTimeFromForm(dateProperty, timeProperty): Date {
        const date = new Date(this.form.value[dateProperty]);
        const time = (<any>document.getElementsByName(timeProperty)[0]).value;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    initTimepicker() {
        $('#timepicker').timepicker().on('changeTime.timepicker', e => this.form.control.markAsDirty());
    }

    getNumberOfUsedPasses() {
        this.currentDate = ConstantsService.months[new Date().getMonth()] + ' ' + new Date().getFullYear();
        this.gotUsedPasses = false;
        this.usedPasses = [];
        const url = `/v1/pass_types_info.json?building_id=${this.parkingPassService.selectedItemData.buildingId}&suite_id=${this.parkingPassService.selectedItemData.suiteId}&parking_lot_id=${this.parkingPassService.selectedItemData.parkingLot.id}`;
        this.api.get('domainParkingPass', url).subscribe(
            res => {
                this.usedPasses = JSON.parse(res._body).filter(usedPass => usedPass.used > 0);
                this.gotUsedPasses = true;
            },
            error => this.api.errorHandler(error, 'Failed to get information about Used Passes.')
        );
    }

    getRecentVisitors() {
        this.recentVisitorsList = [];
        this.gotRecentVisitors = false;
        const url = `/v1/parking_pass_visitors.json?suite_bd_id=${this.parkingPassService.selectedItemData.suiteId}&resident_bd_id=${this.parkingPassService.selectedItemData.residentId}&is-group=1`;
        this.api.get('domainParkingPass', url).subscribe(
            res => {
                if (this.parkingPassService.selectedItemData.suiteId !== 0)
                    this.recentVisitorsList = JSON.parse(res._body).entities;
                else
                    this.recentVisitorsList = [];
                this.gotRecentVisitors = true;
            }
        );
    }

    getUsedPassesString() {
        return this.usedPasses.filter(pass =>
            pass.parkingRuleId == this.parkingPassService.selectedItemData.parkingRule.id || this.parkingPassService.selectedItemData.parkingRule == null
        );
    }

    ngOnDestroy() {
        this.parkingPassService.onDetailedViewToggle.observers = [];
    }

    canDeleteParkingPass() {
        const parkingPassService = this.parkingPassService;
        const isDeclined = parkingPassService.selectedItemData.status == 'declined';
        const isApproved = parkingPassService.selectedItemData.status == 'approved';
        const isPending = parkingPassService.selectedItemData.status == 'pending';
        const bookingStartedInPast = parkingPassService.isBookingStartDateLessThanCurrent(parkingPassService.selectedItemData);
        const bookedInFuture = parkingPassService.isBookingDateLaterThanCurrent(parkingPassService.selectedItemData);
        return parkingPassService.selectedItemData.isCanDelete && (
            (
                isDeclined
                || (isApproved && !bookingStartedInPast)
                || (isPending && bookedInFuture)
            )
            || !this.authenticationService.userIsResident
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-detailed-view/parking-pass-detailed-view.component.ts